// toggle look modal function
function toggleLookModal(modalId, visibility) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  if (visibility === 'show') {
    modal.classList.remove('hidden-modal');
    document.body.style.overflow = 'hidden';
  } else if (visibility === 'hide') {
    modal.classList.add('hidden-modal');
    document.body.style.overflow = '';
  }
}

// custom quick buy component
if (!customElements.get('product-quick-buy')) {
  customElements.define('product-quick-buy', class ProductQuickBuy extends HTMLElement {
    constructor() {
      super();

      this.productId = this.dataset.productId;
      this.variantId = this.dataset.variantId;
      this.hasVariants = this.dataset.hasVariants === 'true';
      this.available = this.dataset.available === 'true';
      this.textAdd = this.dataset.textAdd;
      this.textOut = this.dataset.textOut;
      this.textOptions = this.dataset.textOptions;

      this.variantData = [];
      const variantScript = this.querySelector('script[type="application/json"]');
      if (variantScript) {
        try {
          this.variantData = JSON.parse(variantScript.textContent);
        } catch (err) {
          console.error('Failed to parse variant JSON', err);
        }
      }

      this.button = this.querySelector('[data-action="quick-buy-toggle"], [data-action="quick-buy-single"]');
      this.optionsWrapper = this.querySelector('.quick-buy__options');
      this.form = this.querySelector('[data-action="quick-buy-multi"]');

      this.addEventListener('click', (e) => this.handleClick(e));
      this.addEventListener('change', (e) => this.handleVariantChange(e));
      this.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    handleClick(e) {
      const singleButton = e.target.closest('[data-action="quick-buy-single"]');
      const toggleButton = e.target.closest('[data-action="quick-buy-toggle"]');

      if (singleButton && !this.hasVariants) {
        const variantId = singleButton.dataset.variantId;
        if (variantId) this.addToCart(variantId);
        return;
      }

      if (toggleButton && this.hasVariants) {
        e.preventDefault();
        this.openVariantForm();
      }
    }

    openVariantForm() {
      if (!this.optionsWrapper) return;
      if (this.button) this.button.classList.add('hidden');
      this.optionsWrapper.classList.remove('hidden');
      this.selectFirstAvailableVariant();
    }

    selectFirstAvailableVariant() {
      const firstAvailable = this.variantData.find(v => v.available);
      if (!firstAvailable) return;
      this.variantId = firstAvailable.id;
      const variantOptions = firstAvailable.options;
      const radios = this.form.querySelectorAll('input[type="radio"]');
      variantOptions.forEach((value) => {
        const input = Array.from(radios).find(r => r.value === value);
        if (input) input.checked = true;
      });
      this.updateButtonState(firstAvailable.available);
    }

    handleVariantChange(e) {
      const input = e.target.closest('input[type="radio"]');
      if (!input) return;

      const selectedOptions = [];
      const fieldsets = this.form.querySelectorAll('fieldset');
      fieldsets.forEach(fs => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) selectedOptions.push(checked.value);
      });

      const matchedVariant = this.variantData.find(
        v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
      );

      if (matchedVariant) {
        this.variantId = matchedVariant.id;
        this.updateButtonState(matchedVariant.available);
        this.updatePriceDisplay(matchedVariant.price);
      }
    }

    updateButtonState(available) {
      const submitButton = this.form.querySelector('button[type="submit"]');
      if (!submitButton) return;
      if (!available) {
        submitButton.disabled = true;
        submitButton.textContent = this.textOut;
      } else {
        submitButton.disabled = false;
        submitButton.textContent = this.textAdd;
      }
    }

    updatePriceDisplay(newPrice) {
      const parentCard = this.closest('.card__content');
      if (!parentCard) return;

      const priceContainer = parentCard.querySelector('.price__container');
      if (!priceContainer) return;

      const regularPriceEl = priceContainer.querySelector('.price-item--regular');
      const salePriceEl = priceContainer.querySelector('.price-item--sale');

      const currentPriceText = salePriceEl
        ? salePriceEl.textContent.trim()
        : regularPriceEl?.textContent.trim();

      if (!currentPriceText) return;

      const priceNumber = parseFloat(currentPriceText.replace(/[^\d.,]/g, '').replace(',', '.'));
      const formattedNewPrice = (newPrice / 100).toFixed(2);

      if (priceNumber !== parseFloat(formattedNewPrice)) {
        const updateText = (el) => {
          if (!el) return;
          const oldText = el.textContent;
          el.textContent = el.textContent.replace(
            /[\d.,]+/,
            formattedNewPrice.replace('.', ',')
          );
          // console.log(`[QuickBuy] Updated element text: "${oldText}" → "${el.textContent}"`);
        };

        updateText(regularPriceEl);
        updateText(salePriceEl);
      } else {
        // console.log('[QuickBuy] Price unchanged — no update needed.');
      }
    }

    handleSubmit(e) {
      e.preventDefault();
      if (!this.variantId) return;

      const variantObj = this.variantData.find(v => v.id == this.variantId);
      if (!variantObj || !variantObj.available) {
        alert(this.textOut);
        return;
      }

      this.addToCart(this.variantId);
    }

    addToCart(variantId) {
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        }),
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', config)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            console.error('Error adding to cart:', data.description);
            alert(data.description || 'Unable to add to cart.');
          } else {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
            renderUpdatedCart(data);
            console.log('Added to cart and cart updated:', data);
          }
        })
        .catch(err => console.error('Quick Buy Error:', err));
    }
  });
}

// custom function to add look to cart
// function addLookToCart(modalId) {
//   const modal = document.getElementById(modalId);
//   if (!modal) {
//     console.error('[GetTheLook] Modal not found:', modalId);
//     return;
//   }

//   const productQuickBuys = modal.querySelectorAll('product-quick-buy');
//   if (!productQuickBuys.length) {
//     console.warn('[GetTheLook] No products found inside modal:', modalId);
//     return;
//   }

//   const items = [];

//   productQuickBuys.forEach((quickBuy) => {
//     const variantData = JSON.parse(
//       quickBuy.querySelector('script[type="application/json"]')?.textContent || '[]'
//     );
//     const form = quickBuy.querySelector('[data-action="quick-buy-multi"]');

//     let selectedVariantId = null;

//     if (quickBuy.dataset.hasVariants === 'true' && form) {
//       const selectedOptions = [];
//       form.querySelectorAll('fieldset').forEach(fs => {
//         const checked = fs.querySelector('input[type="radio"]:checked');
//         if (checked) selectedOptions.push(checked.value);
//       });

//       const matchedVariant = variantData.find(
//         v => JSON.stringify(v.options) === JSON.stringify(selectedOptions)
//       );

//       if (matchedVariant && matchedVariant.available) {
//         selectedVariantId = matchedVariant.id;
//       }
//     } else {
//       selectedVariantId = quickBuy.dataset.variantId;
//     }

//     if (selectedVariantId) {
//       items.push({ id: selectedVariantId, quantity: 1 });
//     }
//   });

//   if (!items.length) {
//     console.warn('[GetTheLook] No available variants selected to add.');
//     alert('No products available to add.');
//     return;
//   }

//   console.log('[GetTheLook] Adding items to cart:', items);

//   fetch(window.Shopify.routes.root + 'cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//       'X-Requested-With': 'XMLHttpRequest',
//     },
//     body: JSON.stringify({ items }),
//   })
//     .then(res => res.json())
//     .then(data => {
//       if (data.status) {
//         console.error('[GetTheLook] Error adding to cart:', data.description);
//         alert(data.description || 'Error adding products to cart.');
//       } else {
//         document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
//         renderUpdatedCart(data);
//         console.log('[GetTheLook] Look added and mini cart updated:', data);
//       }
//     })
//     .catch(err => console.error('[GetTheLook] Fetch error:', err));
// }

// 🛒 Helper: update cart bubble and show "Look Added" summary modal
// function renderUpdatedCart(response) {
//   console.log('[CartRender] Starting full cart update...');

//   const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

//   // ---- 1️⃣ Update mini cart sections (if supported) ----
//   if (cart) {
//     try {
//       if (typeof cart.getSectionsToRender === 'function') {
//         console.log('[CartRender] Updating via getSectionsToRender()...');
//         fetch(`${window.Shopify.routes.root}cart.js`)
//           .then(res => res.json())
//           .then(cartData => {
//             const sections = cart.getSectionsToRender().map(section => section.id);
//             const sectionUrl = window.location.pathname;

//             return fetch(`${window.Shopify.routes.root}cart?sections=${sections.join(',')}&sections_url=${sectionUrl}`)
//               .then(res => res.json())
//               .then(sectionResponse => {
//                 response.sections = sectionResponse;
//                 cart.renderContents(response);
//                 if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
//                 console.log('[CartRender] Mini cart refreshed with section data.');
//               });
//           });
//       } else if (typeof cart.renderContents === 'function') {
//         console.log('[CartRender] Cart supports renderContents() only.');
//         cart.renderContents(response);
//         if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
//         console.log('[CartRender] Mini cart updated (no sections).');
//       } else {
//         console.warn('[CartRender] renderContents() not found on cart component.');
//       }
//     } catch (err) {
//       console.error('[CartRender] Failed to render mini cart:', err);
//     }
//   } else {
//     console.warn('[CartRender] No cart component found in DOM.');
//   }

//   // ---- 2️⃣ Update header cart bubble ----
//   fetch(`${window.Shopify.routes.root}cart.js`)
//     .then(res => res.json())
//     .then(cartData => {
//       const totalCount = cartData.item_count || 0;
//       console.log(`[CartRender] Cart count from server: ${totalCount}`);


//       // ---- 3️⃣ Show custom "Look Added" summary modal ----
//       const lookModal = document.querySelector('.get-the-look-modal:not(.hidden-modal)');
//       if (!lookModal) return;

//       // Use the pre-rendered summary modal
//       const summaryModal = document.querySelector('.look-add-summary');
//       if (!summaryModal) {
//         console.warn('[CartRender] Summary modal not found in DOM.');
//         return;
//       }

//       const listContainer = summaryModal.querySelector('.look-add-summary__list');
//       const closeBtn = summaryModal.querySelector('.look-add-summary__close');
//       const continueBtn = summaryModal.querySelector('.look-add-summary__continue');

//       listContainer.innerHTML = ''; // Clear previous content
//       summaryModal.classList.remove('hidden', 'fade-out'); // Show modal
//       summaryModal.classList.add('active');

//       const addedItems = response.items || [];

//       if (addedItems.length > 0) {
//         addedItems.forEach(item => {
//           const variantName =
//             item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
//           listContainer.innerHTML += `
//             <div class="look-add-summary__item">
//               <img src="${item.image || ''}" alt="${item.title}" class="look-add-summary__img">
//               <div class="look-add-summary__details">
//                 <p class="look-add-summary__title">${item.product_title}</p>
//                 ${variantName ? `<p class="look-add-summary__variant">${variantName}</p>` : ''}
//               </div>
//             </div>
//           `;
//         });
//       } else {
//         listContainer.innerHTML = `<p>No products were added to the cart.</p>`;
//       }

//       // Add button listeners
//       const closeSummary = () => {
//         summaryModal.classList.add('fade-out');
//         setTimeout(() => summaryModal.classList.add('hidden'), 500);
//       };

//       [closeBtn, continueBtn].forEach(btn => {
//         if (btn) btn.addEventListener('click', closeSummary);
//       });

//       // Auto-close after 5s
//       setTimeout(() => {
//         closeSummary();
//       }, 5000);
//     })
//     .catch(err => console.error('[CartRender] Failed to update cart bubble:', err));
// }

async function renderUpdatedCart(response) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  // ---- Update mini cart sections ----
  try {
    if (cart) {
      if (typeof cart.getSectionsToRender === 'function') {
        const cartRes = await fetch(`${window.Shopify.routes.root}cart.js`);
        const cartData = await cartRes.json();

        const sections = cart.getSectionsToRender().map(section => section.id);
        const sectionUrl = window.location.pathname;

        const sectionRes = await fetch(
          `${window.Shopify.routes.root}cart?sections=${sections.join(',')}&sections_url=${sectionUrl}`
        );
        const sectionResponse = await sectionRes.json();

        response.sections = sectionResponse;
        cart.renderContents(response);

        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else if (typeof cart.renderContents === 'function') {
        cart.renderContents(response);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else {
        console.warn('[CartRender] renderContents() not found on cart component.');
      }
    }
  } catch (err) {
    console.error('[CartRender] Failed to render mini cart:', err);
  }

  // ---- Update header cart bubble ----
  try {
    const res = await fetch(`${window.Shopify.routes.root}cart.js`);
    const cartData = await res.json();
    const totalCount = cartData.item_count || 0;

    // ---- Show custom "Look Added" summary modal ----
    const lookModal = document.querySelector('.get-the-look-modal:not(.hidden-modal)');
    if (!lookModal) return;

    const summaryModal = document.querySelector('.look-add-summary');
    if (!summaryModal) {
      // console.warn('[CartRender] Summary modal not found in DOM.');
      return;
    }

    const listContainer = summaryModal.querySelector('.look-add-summary__list');
    const closeBtn = summaryModal.querySelector('.look-add-summary__close');
    const continueBtn = summaryModal.querySelector('.look-add-summary__continue');

    // Clear and show
    listContainer.innerHTML = '';
    summaryModal.classList.remove('hidden', 'fade-out');
    summaryModal.classList.add('active');

    const addedItems = response.items || [];

    if (addedItems.length > 0) {
      for (const item of addedItems) {
        console.log(item)
        const variantName =
          item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        const priceValue = item.price / 100;
        const currencySymbol = Shopify.currency?.symbol || '€'; // fallback if symbol not found

        // Remove trailing .00 if unnecessary
        const formattedPrice =
          priceValue % 1 === 0 ? `${priceValue.toFixed(0)}` : priceValue.toFixed(2);
        listContainer.innerHTML += `
          <div class="look-add-summary__item">
            <img src="${item.image || ''}" alt="${item.title}" class="look-add-summary__img">
            <div class="look-add-summary__details">
              <p class="look-add-summary__title">${item.product_title}</p>
              ${variantName ? `<p class="look-add-summary__variant">${variantName}</p>` : ''}
              <p class="look-add-summary__price">${formattedPrice}${currencySymbol}</p>
            </div>
          </div>
        `;
      }
    } else {
      listContainer.innerHTML = `<p>No products were added to the cart.</p>`;
    }

    // ---- Handle close buttons ----
    const closeSummary = () => {
      summaryModal.classList.add('fade-out');
      setTimeout(() => summaryModal.classList.add('hidden'), 500);
    };

    [closeBtn, continueBtn].forEach(btn => {
      if (btn) {
        btn.removeEventListener('click', closeSummary);
        btn.addEventListener('click', closeSummary);
      }
    });

    // Auto-close after 5s
    setTimeout(closeSummary, 500000);
  } catch (err) {
    console.error('[CartRender] Failed to update cart bubble:', err);
  }
}


function addLookToCart(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) {
    console.error('[GetTheLook] Modal not found:', modalId);
    return;
  }

  const productQuickBuys = modal.querySelectorAll('product-quick-buy');
  if (!productQuickBuys.length) {
    console.warn('[GetTheLook] No products found inside modal:', modalId);
    return;
  }

  const items = []; // simple products
  const productsWithVariants = [];

  // Collect product info and detect multi-variant ones
  productQuickBuys.forEach((quickBuy) => {
    const variantData = JSON.parse(
      quickBuy.querySelector('script[type="application/json"]')?.textContent || '[]'
    );
    const hasVariants = quickBuy.dataset.hasVariants === 'true';
    const productCard = quickBuy.closest('.card__content');
    const productTitle =
      productCard?.querySelector('.card__heading a')?.textContent?.trim() || 'Product';
    const productImage = productCard?.querySelector('img')?.src || '';

    if (hasVariants && variantData.length > 1) {
      productsWithVariants.push({
        title: productTitle,
        image: productImage,
        variants: variantData,
      });
    } else {
      const selectedVariantId = quickBuy.dataset.variantId;
      if (selectedVariantId) items.push({ id: selectedVariantId, quantity: 1 });
    }
  });

  // Save simple items temporarily on the modal for later use
  modal.dataset.simpleItems = JSON.stringify(items);

  // If no products with variants, add directly
  if (!productsWithVariants.length) {
    if (!items.length) {
      showCartToast('No products available to add.', 'warning');
      return;
    }
    return sendItemsToCart(items);
  }

  // Get the pre-rendered variant modal inside the current look
  const variantModal = modal.querySelector('.look-variant-modal');
  if (!variantModal) {
    console.error('[GetTheLook] Variant modal not found inside current look modal:', modalId);
    return;
  }

  const productContainer = variantModal.querySelector('.look-variant-modal__products');
  const addAllBtn = variantModal.querySelector('.look-variant-modal__add-all');

  // Show the modal
  variantModal.classList.remove('hidden');
  variantModal.classList.add('active');

  const variantRadios = productContainer.querySelectorAll('input[type="radio"]');
  const totalVariantProducts = productContainer.querySelectorAll('.look-variant-product').length;
  let selectedVariants = [];

  // Handle variant selection
  variantRadios.forEach((radio) => {
    radio.addEventListener('change', () => {
      const group = radio.name;
      const variantId = radio.value;
      const available = radio.dataset.available === 'true';

      selectedVariants = selectedVariants.filter((v) => v.group !== group);
      if (available) selectedVariants.push({ group, id: variantId });

      if (totalVariantProducts === 1) {
        // Auto-add if only one product needs selection
        const finalItems = [...items, { id: variantId, quantity: 1 }];
        closeVariantModal(modalId);
        sendItemsToCart(finalItems);
      } else {
        // Show "Add All" only when all selected
        if (selectedVariants.length === totalVariantProducts) {
          addAllBtn.classList.remove('hidden');
        }
      }
    });
  });
}

async function sendItemsToCart(items) {
  if (!items || !items.length) {
    showCartToast('⚠️ No items to add.', 'warning');
    console.warn('[Cart] No items to add.');
    return;
  }

  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    body: JSON.stringify({ items }),
  };

  try {
    const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, config);
    const data = await res.json();

    if (data.status) {
      console.error('[Cart] Error adding to cart:', data.description);
      showCartToast(data.description || 'Unable to add one or more products to the cart.', 'error');
      return;
    }

    console.log('[Cart] Successfully added items:', data);
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));

    // ✅ Update cart bubble and show summary modal
    renderUpdatedCart(data);
  } catch (err) {
    console.error('[Cart] Fetch error while adding items:', err);
    showCartToast('An error occurred while adding items to the cart.', 'error');
  }
}

function showCartToast(message, type = 'info') {
  // Remove any existing toast first
  const existing = document.querySelector('.cart-toast');
  if (existing) existing.remove();

  // Create toast element
  const toast = document.createElement('div');
  toast.className = `cart-toast cart-toast--${type}`;
  toast.innerHTML = `
    <div class="cart-toast__content">
      <span class="cart-toast__message">${message}</span>
    </div>
  `;

  document.body.appendChild(toast);

  // Animate in
  setTimeout(() => toast.classList.add('visible'), 10);

  // Auto-close after 5s
  setTimeout(() => {
    toast.classList.remove('visible');
    setTimeout(() => toast.remove(), 400);
  }, 5000);
}

// Close variant modal
function closeVariantModal(modalId) {
  const modal = document.getElementById(modalId);
  const variantModal = modal?.querySelector('.look-variant-modal');
  if (!variantModal) return;

  variantModal.classList.remove('active');
  setTimeout(() => variantModal.classList.add('hidden'), 300);
}

// Confirm variants & add all selected
function confirmLookVariants(modalId) {
  const modal = document.getElementById(modalId);
  if (!modal) return;

  const variantModal = modal.querySelector('.look-variant-modal');
  const productContainer = variantModal.querySelector('.look-variant-modal__products');

  const selectedRadios = productContainer.querySelectorAll('input[type="radio"]:checked');
  const selectedVariantItems = Array.from(selectedRadios).map((r) => ({
    id: r.value,
    quantity: 1,
  }));

  // ✅ Also include the simple products from the modal dataset
  const simpleItems = JSON.parse(modal.dataset.simpleItems || '[]');

  const finalItems = [...simpleItems, ...selectedVariantItems];

  if (!finalItems.length) {
    showCartToast('⚠️ Please select at least one product.', 'warning');
    return;
  }

  closeVariantModal(modalId);
  sendItemsToCart(finalItems);
}